/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { useTranslation } from 'react-i18next';
// mui
import { Box, Modal } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
// TODO: remove when backend will be ready
import { categories, countries, currencies, driver_categories, education_level, industries, lang_skills, langs } from '../../../settings';

const MobileAdvancedSearch = ({
  errors,
  searchAgeTo,
  searchParams,
  handleKeyDown,
  searchAgeFrom,
  subCategories,
  searchSalaryTo,
  searchSalaryFrom,
  handleResetFilters,
  handleAddSearchItem,
  searchSalaryCurrency,
  sortValueRadioSettings,
  getSubCategoriesOptions,
  // handleChangeSearchPlace,
  handleRemoveSearchParam,
  handleChangeAgeAndSalary,
  searchLogicRadioSettings,
  debouncedGetCitiesOptions,
  resultsPeriodRadioSettings,
  // searchPlaceCheckboxSettings,
  searchGenderCheckboxSettings,
  searchLocationCheckboxSettings,
  searchWorkTypeCheckboxSettings,
  handleChangeSearchDriverLicense,
  handleChangeSortValueSearchLogic,
  searchExperienceCheckboxSettings,
  handleChangeExperienceWorkTypeGender,
  handleChangeRegionsCategoriesLanguages,
  handleChangeIndustryEducationDriverCategories,
}) => {
  const { t } = useTranslation('global');

  const {
    sortValue = '',
    searchLogic = '',
    // searchPlace = [],
    searchGender = [],
    resultsPeriod = '',
    searchRegions = [],
    searchLocation = [],
    searchIndustry = [],
    searchWorkType = [],
    searchEducation = [],
    searchLanguages = [],
    searchCategories = [],
    searchExperience = [],
    searchDriverCategories = [],
    searchDriverLicense = false,
  } = searchParams;

  const initialValues = {
    searchAgeTo: '',
    searchGender: [],
    searchAgeFrom: '',
    searchLocation: [],
    searchIndustry: [],
    searchLogic: 'all',
    searchSalaryTo: '',
    searchWorkType: [],
    searchEducation: [],
    searchExperience: [],
    searchSalaryFrom: '',
    sortValue: 'newFirst',
    searchPlace: ['titles'],
    searchSalaryCurrency: '',
    resultsPeriod: 'allTime',
    searchDriverCategories: [],
    searchDriverLicense: false,
    searchRegions: [{ country: null, cities: [] }],
    searchLanguages: [{ lng: null, lng_skill: null }],
    searchCategories: [{ category: null, sub_categories: [] }],
  };

  const [open, setOpen] = useState(false);
  const [showFilterSection, setShowFilterSection] = useState({
    age: false,
    sortBy: true,
    gender: false,
    region: false,
    salary: false,
    industry: false,
    workType: false,
    languages: false,
    education: false,
    categories: false,
    experience: false,
    driverLicense: false,
    resultsPeriod: false,
    advancedSearch: false,
  });

  const toggleFilterSection = name => {
    setShowFilterSection(prevShowFilterSection => ({
      ...prevShowFilterSection,
      [name]: !prevShowFilterSection[name],
    }));
  };

  const deepEqual = (obj1, obj2) => {
    if (obj1 === obj2) return true;

    if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) return false;

    for (const key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  };

  const countDifferences = (initialValues, searchParams) => {
    let counter = 0;

    for (const key in initialValues) {
      if (Array.isArray(initialValues[key])) {
        if (['searchRegions', 'searchLanguages', 'searchCategories'].includes(key)) {
          if (
            initialValues[key].length !== searchParams[key].length ||
            initialValues[key].some((item, index) => !deepEqual(item, searchParams[key][index]))
          ) {
            counter += 1;
          }
        } else {
          if (
            initialValues[key].length !== searchParams[key].length ||
            initialValues[key].some((value, index) => value !== searchParams[key][index])
          ) {
            counter += 1;
          }
        }
      } else {
        if (initialValues[key] !== searchParams[key]) {
          counter += 1;
        }
      }
    }

    return counter;
  };

  const hasDifference = field => JSON.stringify(initialValues[field]) !== JSON.stringify(searchParams[field]);

  return (
    <section className='advancedSearchSection'>
      <button
        type='button'
        className='mb-4 btn button2'
        onClick={() => setOpen(true)}
      >
        {t('JobseekerSearchList.filters')}
        {` (${countDifferences(initialValues, searchParams)})`}
        <TuneIcon sx={{ ml: '20px' }} />
      </button>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box
          className=' container advancedSearchSection'
          sx={{
            p: '12px',
            pb: '0px',
            height: '100%',
            overflowY: 'auto',
            position: 'relative',
            backgroundColor: '#FFFFFF',
          }}
        >
          <button type='button' className='showFilterSectionBtn' onClick={() => toggleFilterSection('sortBy')}>
            {t('JobseekerSearchList.sortBy')}
            {hasDifference('sortValue') && ' (1)'}
            {
              showFilterSection.sortBy
                ? <KeyboardArrowUpOutlinedIcon sx={{ ml: 'auto' }} />
                : <KeyboardArrowDownOutlinedIcon sx={{ ml: 'auto' }} />
            }
          </button>
          {
            showFilterSection.sortBy && (
              <div className='paramsBox'>
                <div className='searchLogicBox'>
                  {
                    sortValueRadioSettings.map(i => (
                      <label key={i.value} className={`radioLabel ${sortValue === i.value && 'selected'}`}>
                        <input
                          type='radio'
                          value={i.value}
                          checked={sortValue === i.value}
                          onChange={e => handleChangeSortValueSearchLogic(e, 'sortValue')}
                        />
                        {t(`JobseekerSearchList.${i.text}`)}
                      </label>
                    ))
                  }
                </div>
              </div>
            )
          }
          <button type='button' className='showFilterSectionBtn' onClick={() => toggleFilterSection('resultsPeriod')}>
            {t('JobseekerSearchList.resultsPeriod')}
            {hasDifference('resultsPeriod') && ' (1)'}
            {
              showFilterSection.resultsPeriod
                ? <KeyboardArrowUpOutlinedIcon sx={{ ml: 'auto' }} />
                : <KeyboardArrowDownOutlinedIcon sx={{ ml: 'auto' }} />
            }
          </button>
          {
            showFilterSection.resultsPeriod && (
              <div className='paramsBox'>
                <div className='searchLogicBox'>
                  {
                    resultsPeriodRadioSettings.map(i => (
                      <label key={i.value} className={`radioLabel ${resultsPeriod === i.value && 'selected'}`}>
                        <input
                          type='radio'
                          value={i.value}
                          checked={resultsPeriod === i.value}
                          onChange={e => handleChangeSortValueSearchLogic(e, 'resultsPeriod')}
                        />
                        {t(`JobseekerSearchList.${i.text}`)}
                      </label>
                    ))
                  }
                </div>
              </div>
            )
          }
          <button type='button' className='showFilterSectionBtn' onClick={() => toggleFilterSection('advancedSearch')}>
            {t('jobseekerListing.advancedSearch')}
            {(hasDifference('searchLogic') || hasDifference('searchPlace')) && ' (1)'}
            {
              showFilterSection.advancedSearch
                ? <KeyboardArrowUpOutlinedIcon sx={{ ml: 'auto' }} />
                : <KeyboardArrowDownOutlinedIcon sx={{ ml: 'auto' }} />
            }
          </button>
          {
            showFilterSection.advancedSearch && (
              <>
                <div className='paramsBox'>
                  <p>
                    {t('jobseekerListing.searchLogic')}
                  </p>
                  <div className='searchLogicBox'>
                    {
                      searchLogicRadioSettings.map(i => (
                        <label key={i.value} className={`radioLabel ${searchLogic === i.value && 'selected'}`}>
                          <input
                            type='radio'
                            value={i.value}
                            checked={searchLogic === i.value}
                            onChange={e => handleChangeSortValueSearchLogic(e, 'searchLogic')}
                          />
                          {t(`jobseekerListing.${i.text}`)}
                        </label>
                      ))
                    }
                  </div>
                </div>
                {/* <div className='paramsBox'>
                  <p>
                    {t('jobseekerListing.searchPlace')}
                  </p>
                  <div className='searchPlaceBox'>
                    {
                      searchPlaceCheckboxSettings.map(i => (
                        <label key={i.name} className='checkboxLabel'>
                          <input
                            name={i.name}
                            type='checkbox'
                            onChange={handleChangeSearchPlace}
                            checked={searchPlace.includes(i.name)}
                          />
                          {t(`jobseekerListing.${i.text}`)}
                        </label>
                      ))
                    }
                  </div>
                </div> */}
              </>
            )
          }
          <button type='button' className='showFilterSectionBtn' onClick={() => toggleFilterSection('region')}>
            {t('jobseekerListing.region')}
            {hasDifference('searchRegions') && ' (1)'}
            {
              showFilterSection.region
                ? <KeyboardArrowUpOutlinedIcon sx={{ ml: 'auto' }} />
                : <KeyboardArrowDownOutlinedIcon sx={{ ml: 'auto' }} />
            }
          </button>
          {
            showFilterSection.region && (
              searchRegions?.map((i, index) => (
                <>
                  <div className='paramsBox'>
                    <p>
                      {t('jobseekerListing.moving')}
                    </p>
                    <div className='searchWorkTypeBox'>
                      {
                        searchLocationCheckboxSettings.map(i => (
                          <label key={i.name} className='checkboxLabel'>
                            <input
                              name={i.name}
                              type='checkbox'
                              checked={searchLocation.includes(i.name)}
                              onChange={e => handleChangeExperienceWorkTypeGender(e, 'searchLocation')}
                            />
                            {t(`jobseekerListing.${i.text}`)}
                          </label>
                        ))
                      }
                    </div>
                  </div>
                  <div key={index} className='paramsBox'>
                    <p>
                      {t('jobseekerListing.country')}
                    </p>
                    <div className='regionParamsBox'>
                      <Select
                        isClearable
                        value={i.country}
                        name={`country_${index}`}
                        placeholder={t('jobseekerListing.selectCountry')}
                        noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
                        options={countries.map(i => ({ value: i.id, label: i.name }))}
                        onChange={selectedOption => handleChangeRegionsCategoriesLanguages('searchRegions', 'country', selectedOption, index)}
                      />
                    </div>
                    {
                      i.country && (
                        <div>
                          <p>
                            {t('jobseekerListing.city')}
                          </p>
                          <div className='regionParamsBox'>
                            <AsyncSelect
                              isMulti
                              value={i.cities}
                              name={`cities_${index}`}
                              placeholder={t('jobseekerListing.enterCityName')}
                              loadingMessage={() => t('jobseekerListing.pleaseWait')}
                              options={countries.map(i => ({ value: i.id, label: i.name }))}
                              loadOptions={inputValue => debouncedGetCitiesOptions(inputValue, index)}
                              onChange={selectedOptions => handleChangeRegionsCategoriesLanguages('searchRegions', 'cities', selectedOptions, index, 5)}
                              noOptionsMessage={
                                ({ inputValue }) => inputValue.length >= 2
                                  ? t('jobseekerListing.noOptionsFound')
                                  : t('jobseekerListing.enterCityName')
                              }
                              styles={{
                                multiValue: baseStyles => ({
                                  ...baseStyles,
                                  width: '100%',
                                  justifyContent: 'space-between',
                                }),
                              }}
                            />
                            {
                              errors.searchRegions[index]?.cities && (
                                <div className='text-danger'>{errors.searchRegions[index]?.cities}</div>
                              )
                            }
                          </div>
                        </div>
                      )
                    }
                    <div className='advancedSearchButtons'>
                      <button
                        type='button'
                        className='mb-3'
                        onClick={() => handleAddSearchItem('searchRegions')}
                        disabled={i.country === null || searchRegions?.length > 2}
                      >
                        <i className='fa-solid fa-plus' />
                        {t('jobseekerListing.addRegion')}
                      </button>
                      {
                        searchRegions?.length > 1 && (
                          <button
                            type='button'
                            className='mb-3'
                            onClick={() => handleRemoveSearchParam('searchRegions', index)}
                          >
                            <i className='fa-solid fa-trash' />
                            {t('jobseekerListing.remove')}
                          </button>
                        )
                      }
                    </div>
                  </div>
                </>
              ))
            )
          }
          <button type='button' className='showFilterSectionBtn' onClick={() => toggleFilterSection('categories')}>
            {t('jobseekerListing.categories')}
            {hasDifference('searchCategories') && ' (1)'}
            {
              showFilterSection.categories
                ? <KeyboardArrowUpOutlinedIcon sx={{ ml: 'auto' }} />
                : <KeyboardArrowDownOutlinedIcon sx={{ ml: 'auto' }} />
            }
          </button>
          {
            showFilterSection.categories && (
              searchCategories?.map((i, index) => (
                <div key={index} className='paramsBox'>
                  <p>
                    {t('jobseekerListing.category')}
                  </p>
                  <div className='categoryParamsBox'>
                    <Select
                      isClearable
                      value={i.category}
                      name={`category_${index}`}
                      placeholder={t('jobseekerListing.selectCategory')}
                      noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
                      options={categories.map(i => ({ value: i.id, label: i.name }))}
                      onChange={selectedOption => {
                        handleChangeRegionsCategoriesLanguages('searchCategories', 'category', selectedOption, index);
                        getSubCategoriesOptions(i.category?.value, index);
                      }}
                    />
                  </div>
                  {
                    i.category && (
                      <div>
                        <p>
                          {t('jobseekerListing.subCategory')}
                        </p>
                        <div className='categoryParamsBox'>
                          <Select
                            isMulti
                            value={i.sub_categories}
                            name={`sub_category_${index}`}
                            options={subCategories[index]?.map(i => (i))}
                            placeholder={t('jobseekerListing.selectSubCategory')}
                            noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
                            onChange={
                              selectedOptions => handleChangeRegionsCategoriesLanguages('searchCategories', 'sub_categories', selectedOptions, index, 5)
                            }
                            styles={{
                              multiValue: baseStyles => ({
                                ...baseStyles,
                                width: '100%',
                                justifyContent: 'space-between',
                              }),
                            }}
                          />
                          {
                            errors.searchCategories[index]?.sub_categories && (
                              <div className='text-danger'>{errors.searchCategories[index]?.sub_categories}</div>
                            )
                          }
                        </div>
                      </div>
                    )
                  }
                  <div className='advancedSearchButtons'>
                    <button
                      type='button'
                      className='mb-3'
                      onClick={() => handleAddSearchItem('searchCategories')}
                      disabled={i.category == null || searchCategories?.length > 2}
                    >
                      <i className='fa-solid fa-plus' />
                      {t('jobseekerListing.addCategory')}
                    </button>
                    {
                      searchCategories?.length > 1 && (
                        <button
                          type='button'
                          className='mb-3'
                          onClick={() => handleRemoveSearchParam('searchCategories', index)}
                        >
                          <i className='fa-solid fa-trash' />
                          {t('jobseekerListing.remove')}
                        </button>
                      )
                    }
                  </div>
                </div>
              ))
            )
          }
          <button type='button' className='showFilterSectionBtn' onClick={() => toggleFilterSection('salary')}>
            {t('jobseekerListing.salary')}
            {(hasDifference('searchSalaryTo') || hasDifference('searchSalaryFrom') || hasDifference('searchSalaryCurrency')) && ' (1)'}
            {
              showFilterSection.salary
                ? <KeyboardArrowUpOutlinedIcon sx={{ ml: 'auto' }} />
                : <KeyboardArrowDownOutlinedIcon sx={{ ml: 'auto' }} />
            }
          </button>
          {
            showFilterSection.salary && (
              <div className='paramsBox row'>
                <div className='col-4'>
                  <p>
                    {t('jobseekerListing.salaryFrom')}
                  </p>
                  <div className='searchSalaryBox'>
                    <input
                      type='text'
                      name='searchSalaryFrom'
                      value={searchSalaryFrom}
                      onKeyDown={handleKeyDown}
                      onChange={handleChangeAgeAndSalary}
                      placeholder={t('jobseekerListing.salaryFrom')}
                    />
                  </div>
                </div>
                <div className='col-4'>
                  <p>
                    {t('jobseekerListing.salaryTo')}
                  </p>
                  <div className='searchSalaryBox'>
                    <input
                      type='text'
                      name='searchSalaryTo'
                      value={searchSalaryTo}
                      onKeyDown={handleKeyDown}
                      onChange={handleChangeAgeAndSalary}
                      placeholder={t('jobseekerListing.salaryTo')}
                    />
                  </div>
                </div>
                <div className='col-4'>
                  <p>
                    {t('jobseekerListing.salaryCurrency')}
                  </p>
                  <div className='searchSalaryBox'>
                    <select
                      type='text'
                      name='searchSalaryCurrency'
                      value={searchSalaryCurrency}
                      onChange={handleChangeAgeAndSalary}
                      placeholder={t('jobseekerListing.salaryCurrency')}
                    >
                      <option value=''>{t('jobseekerListing.salaryCurrency')}</option>
                      {
                        Object.entries(currencies).map(([key, value]) => (
                          <option key={key} value={key}>
                            {value}
                          </option>
                        ))
                      }
                    </select>
                  </div>
                </div>
              </div>
            )
          }
          <button type='button' className='showFilterSectionBtn' onClick={() => toggleFilterSection('experience')}>
            {t('jobseekerListing.experience')}
            {hasDifference('searchExperience') && ' (1)'}
            {
              showFilterSection.experience
                ? <KeyboardArrowUpOutlinedIcon sx={{ ml: 'auto' }} />
                : <KeyboardArrowDownOutlinedIcon sx={{ ml: 'auto' }} />
            }
          </button>
          {
            showFilterSection.experience && (
              <div className='paramsBox'>
                <div className='searchExperienceBox'>
                  {
                    searchExperienceCheckboxSettings.map(i => (
                      <label key={i.name} className='checkboxLabel'>
                        <input
                          name={i.name}
                          type='checkbox'
                          checked={searchExperience.includes(i.name)}
                          onChange={e => handleChangeExperienceWorkTypeGender(e, 'searchExperience')}
                        />
                        {t(`jobseekerListing.${i.text}`)}
                      </label>
                    ))
                  }
                </div>
              </div>
            )
          }
          <button type='button' className='showFilterSectionBtn' onClick={() => toggleFilterSection('industry')}>
            {t('jobseekerListing.industry')}
            {hasDifference('searchIndustry') && ' (1)'}
            {
              showFilterSection.industry
                ? <KeyboardArrowUpOutlinedIcon sx={{ ml: 'auto' }} />
                : <KeyboardArrowDownOutlinedIcon sx={{ ml: 'auto' }} />
            }
          </button>
          {
            showFilterSection.industry && (
              <div className='paramsBox'>
                <div className='industryParamsBox'>
                  <Select
                    isMulti
                    name='industry'
                    value={searchIndustry}
                    placeholder={t('jobseekerListing.selectIndustry')}
                    noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
                    options={industries.map(i => ({ value: i.id, label: i.name }))}
                    onChange={selectedOption => handleChangeIndustryEducationDriverCategories('searchIndustry', selectedOption, 5)}
                    styles={{
                      multiValue: baseStyles => ({
                        ...baseStyles,
                        width: '100%',
                        justifyContent: 'space-between',
                      }),
                    }}
                  />
                  {
                    errors.searchIndustry && (
                      <div className='text-danger'>{errors.searchIndustry}</div>
                    )
                  }
                </div>
              </div>
            )
          }
          <button type='button' className='showFilterSectionBtn' onClick={() => toggleFilterSection('workType')}>
            {t('jobseekerListing.workType')}
            {hasDifference('searchWorkType') && ' (1)'}
            {
              showFilterSection.workType
                ? <KeyboardArrowUpOutlinedIcon sx={{ ml: 'auto' }} />
                : <KeyboardArrowDownOutlinedIcon sx={{ ml: 'auto' }} />
            }
          </button>
          {
            showFilterSection.workType && (
              <div className='paramsBox'>
                <div className='searchWorkTypeBox'>
                  {
                    searchWorkTypeCheckboxSettings.map(i => (
                      <label key={i.name} className='checkboxLabel'>
                        <input
                          name={i.name}
                          type='checkbox'
                          checked={searchWorkType.includes(i.name)}
                          onChange={e => handleChangeExperienceWorkTypeGender(e, 'searchWorkType')}
                        />
                        {t(`jobseekerListing.${i.text}`)}
                      </label>
                    ))
                  }
                </div>
              </div>
            )
          }
          <button type='button' className='showFilterSectionBtn' onClick={() => toggleFilterSection('education')}>
            {t('jobseekerListing.education')}
            {hasDifference('searchEducation') && ' (1)'}
            {
              showFilterSection.education
                ? <KeyboardArrowUpOutlinedIcon sx={{ ml: 'auto' }} />
                : <KeyboardArrowDownOutlinedIcon sx={{ ml: 'auto' }} />
            }
          </button>
          {
            showFilterSection.education && (
              <div className='paramsBox'>
                <div className='educationParamsBox'>
                  <Select
                    isMulti
                    name='education'
                    value={searchEducation}
                    placeholder={t('jobseekerListing.selectEducation')}
                    noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
                    options={education_level.map(i => ({ value: i.value, label: i.name }))}
                    onChange={selectedOption => handleChangeIndustryEducationDriverCategories('searchEducation', selectedOption)}
                    styles={{
                      multiValue: baseStyles => ({
                        ...baseStyles,
                        width: '100%',
                        justifyContent: 'space-between',
                      }),
                    }}
                  />
                </div>
              </div>
            )
          }
          <button type='button' className='showFilterSectionBtn' onClick={() => toggleFilterSection('languages')}>
            {t('jobseekerListing.languages')}
            {hasDifference('searchLanguages') && ' (1)'}
            {
              showFilterSection.languages
                ? <KeyboardArrowUpOutlinedIcon sx={{ ml: 'auto' }} />
                : <KeyboardArrowDownOutlinedIcon sx={{ ml: 'auto' }} />
            }
          </button>
          {
            showFilterSection.languages && (
              searchLanguages?.map((i, index) => (
                <div key={index} className='paramsBox'>
                  <p>
                    {t('jobseekerListing.language')}
                  </p>
                  <div className='languageParamsBox'>
                    <Select
                      isClearable
                      value={i.lng}
                      name={`lng_${index}`}
                      placeholder={t('jobseekerListing.selectLanguage')}
                      noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
                      options={langs.map(i => ({ value: i.id, label: i.name }))}
                      onChange={selectedOption => handleChangeRegionsCategoriesLanguages('searchLanguages', 'lng', selectedOption, index)}
                    />
                  </div>
                  {
                    i.lng && (
                      <div>
                        <p>
                          {t('jobseekerListing.lngSkill')}
                        </p>
                        <div className='languageParamsBox'>
                          <Select
                            isClearable
                            value={i.lng_skill}
                            name={`lng_skill_${index}`}
                            placeholder={t('jobseekerListing.selectLngSkill')}
                            noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
                            options={lang_skills.map(i => ({ value: i.id, label: i.name }))}
                            onChange={selectedOption => handleChangeRegionsCategoriesLanguages('searchLanguages', 'lng_skill', selectedOption, index)}
                          />
                        </div>
                      </div>
                    )
                  }
                  <div className='advancedSearchButtons'>
                    <button
                      type='button'
                      className='mb-3'
                      onClick={() => handleAddSearchItem('searchLanguages')}
                      disabled={i.lng === null || searchLanguages?.length > 2}
                    >
                      <i className='fa-solid fa-plus' />
                      {t('jobseekerListing.addLanguage')}
                    </button>
                    {
                      searchLanguages?.length > 1 && (
                        <button
                          type='button'
                          className='mb-3'
                          onClick={() => handleRemoveSearchParam('searchLanguages', index)}
                        >
                          <i className='fa-solid fa-trash' />
                          {t('jobseekerListing.remove')}
                        </button>
                      )
                    }
                  </div>
                </div>
              ))
            )
          }
          <button type='button' className='showFilterSectionBtn' onClick={() => toggleFilterSection('age')}>
            {t('jobseekerListing.age')}
            {(hasDifference('searchAgeTo') || hasDifference('searchAgeFrom')) && ' (1)'}
            {
              showFilterSection.age
                ? <KeyboardArrowUpOutlinedIcon sx={{ ml: 'auto' }} />
                : <KeyboardArrowDownOutlinedIcon sx={{ ml: 'auto' }} />
            }
          </button>
          {
            showFilterSection.age && (
              <div className='paramsBox row'>
                <div className='col-6'>
                  <p>
                    {t('jobseekerListing.ageFrom')}
                  </p>
                  <div className='searchAgeBox'>
                    <input
                      type='text'
                      name='searchAgeFrom'
                      value={searchAgeFrom}
                      onKeyDown={handleKeyDown}
                      onChange={handleChangeAgeAndSalary}
                      placeholder={t('jobseekerListing.ageFrom')}
                    />
                  </div>
                </div>
                <div className='col-6'>
                  <p>
                    {t('jobseekerListing.ageTo')}
                  </p>
                  <div className='searchAgeBox'>
                    <input
                      type='text'
                      name='searchAgeTo'
                      value={searchAgeTo}
                      onKeyDown={handleKeyDown}
                      onChange={handleChangeAgeAndSalary}
                      placeholder={t('jobseekerListing.ageTo')}
                    />
                  </div>
                </div>
              </div>
            )
          }
          <button type='button' className='showFilterSectionBtn' onClick={() => toggleFilterSection('gender')}>
            {t('jobseekerListing.gender')}
            {hasDifference('searchGender') && ' (1)'}
            {
              showFilterSection.gender
                ? <KeyboardArrowUpOutlinedIcon sx={{ ml: 'auto' }} />
                : <KeyboardArrowDownOutlinedIcon sx={{ ml: 'auto' }} />
            }
          </button>
          {
            showFilterSection.gender && (
              <div className='paramsBox'>
                <div className='searchGenderBox'>
                  {
                    searchGenderCheckboxSettings.map(i => (
                      <label key={i.name} className='checkboxLabel'>
                        <input
                          name={i.name}
                          type='checkbox'
                          checked={searchGender.includes(i.name)}
                          onChange={e => handleChangeExperienceWorkTypeGender(e, 'searchGender')}
                        />
                        {t(`jobseekerListing.${i.text}`)}
                      </label>
                    ))
                  }
                </div>
              </div>
            )
          }
          <button type='button' className='showFilterSectionBtn' onClick={() => toggleFilterSection('driverLicense')}>
            {t('jobseekerListing.driverLicense')}
            {(hasDifference('searchDriverLicense') || hasDifference('searchDriverCategories')) && ' (1)'}
            {
              showFilterSection.driverLicense
                ? <KeyboardArrowUpOutlinedIcon sx={{ ml: 'auto' }} />
                : <KeyboardArrowDownOutlinedIcon sx={{ ml: 'auto' }} />
            }
          </button>
          {
            showFilterSection.driverLicense && (
              <>
                <div className='searchDriverLicenseBox'>
                  <label className='checkboxLabel'>
                    <input
                      type='checkbox'
                      name='searchDriverLicense'
                      checked={searchDriverLicense}
                      onChange={handleChangeSearchDriverLicense}
                    />
                    {t('jobseekerListing.driverLicense')}
                  </label>
                </div>
                {
                  searchDriverLicense && (
                    <div>
                      <p>
                        {t('jobseekerListing.driverCategories')}
                      </p>
                      <div className='searchDriverLicenseBox'>
                        <Select
                          isMulti
                          menuPlacement='top'
                          name='searchDriverCategories'
                          value={searchDriverCategories}
                          placeholder={t('jobseekerListing.selectDriverCategory')}
                          noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
                          options={driver_categories.map(i => ({ value: i.id, label: i.name }))}
                          onChange={selectedOption => handleChangeIndustryEducationDriverCategories('searchDriverCategories', selectedOption)}
                        />
                      </div>
                    </div>
                  )
                }
              </>
            )
          }
          <Box
            sx={{
              bottom: 0,
              p: '12px',
              display: 'flex',
              position: 'sticky',
              backgroundColor: '#FFFFFF',
              borderTop: '1px solid grey',
              justifyContent: 'space-between',
            }}
          >
            <button
              type='button'
              className='btn button1'
              onClick={() => setOpen(false)}
            >
              {/* <i className='fa-solid fa-arrows-rotate' /> */}
              {t('jobseekerListing.apply')}
            </button>
            <div className='advancedSearchButtons'>
              <button
                type='button'
                onClick={() => handleResetFilters()}
              >
                <i className='fa-solid fa-arrows-rotate' />
                {t('jobseekerListing.resetFilters')}
              </button>
            </div>
          </Box>
        </Box>
      </Modal>
    </section>
  );
};

export default MobileAdvancedSearch;
